module.exports = {
	"$schema": "http://json-schema.org/draft-04/schema#",
	"type": "object",
	"properties": {
		"accessToken": {
			"type": "string",
			"messages": {
				"type": "accessToken must be a string",
				"required": "accessToken is required"
			}
		},
		"id": {
			"type": "string",
			"messages": {
				"type": "id must be a string",
				"required": "id is required"
			}
		},
		"settings": {
			"$ref": "#settings"
		},
		"pageName": {
			"type": "string",
			"messages": {
				"type": "pageName must be a string"
			}
		},
		"filters": {
			"type": "array",
			"items": {
				"type": "object",
				"oneOf": [
					{
						"$ref": "#basicFilter"
					},
					{
						"$ref": "#advancedFilter"
					}
				]
			},
			"invalidMessage": "filters property is invalid"
		}
	},
	"required": [
		"accessToken",
		"id"
	]
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/schemas/reportLoadConfiguration.json
 ** module id = 3
 ** module chunks = 0
 **/